import { SwApiStore } from "@sourcewhale/shared/src/svelte/api-stores/sw-api-store";
import { getCurrencies } from "../api/currencies.js";

export const currenciesStore = SwApiStore({
  get: getCurrencies,
  init: () => [],
  cacheKey: "currenciesData",
});
